export const CREATE_ADVANCEDREPORT_DEFINITION = 'CREATE_ADVANCEDREPORT_DEFINITION';
